import { InfoIcon } from "../../icons"
import { runTour, type TourStep } from "../../lib/tours/runTour"

type TourButtonProps = {
  steps: TourStep[]
  label?: string
}

/**
 * Launches a driver.js guided tour over the page's real elements — used to
 * validate whether a drafted user story's flow actually exists yet
 * (see src/lib/tours). Styled like the other toolbar escape-hatch buttons
 * (ModuleLayout's `toolbar.extra`).
 */
export function TourButton({ steps, label = "Ver tour" }: TourButtonProps) {
  return (
    <button
      type="button"
      onClick={() => runTour(steps)}
      className="flex items-center gap-1.5 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/[0.04]"
    >
      <InfoIcon className="size-4" />
      {label}
    </button>
  )
}

export default TourButton
